<!--<ion-header class="page-header ion-no-border">-->
<!--  <ion-toolbar mode="ios">-->
<!--    <ion-buttons slot="start" class="back">-->
<!--      <ion-back-button text="" icon="chevron-back-outline" defaultHref="/main"></ion-back-button>-->
<!--    </ion-buttons>-->
<!--    <app-page-title [title]="title" [subtitle]="subtitle"></app-page-title>-->
<!--  </ion-toolbar>-->
<!--</ion-header>-->

<app-page-wrapper
  [useFooter]="true"
  [useHeader]="true"
  [useBackBtn]="true"
  [title]="title"
  [subtitle]="subtitle"
>
  <ion-content>
    <div class="step-online-credit" *ngIf="loaded$ | async">
      <div class="select-accounts" *ngIf="availableAccounts && availableAccounts.length; else openacc">
        <div class="select-accounts__label">Выберите счет для выдачи кредита</div>
        <app-products-select
                [products]="availableAccounts"
                (change)="setAccount($event)"
        >
        </app-products-select>
      </div>
      <ng-template #openacc>
        <div class="select-accounts" [formGroup]="accountForm">
          <div class="select-accounts__label">
            Открытие счета для выдачи кредита
          </div>
          <app-form-checkbox
                  *ngIf="accountAgreeRules.enabled"
                  formControlName="accountAgreeRules"
                  [option]="accountAgreeRules.text"
                  [url]="accountAgreeRules.url"
          ></app-form-checkbox>
        </div>

      </ng-template>
    </div>
  </ion-content>

  <ng-container footer *ngIf="loaded$ | async">
    <ion-button expand="block" class="button primary block" ripple-effect (click)="handleButtonClick()">
      Далее
    </ion-button>
  </ng-container>


</app-page-wrapper>


<!-- </app-page> -->
